interface TooltipEntry {
	name?: string | number;
	value?: number | string;
	color?: string;
	payload?: unknown;
}

interface ChartTooltipProps {
	active?: boolean;
	label?: string | number;
	payload?: ReadonlyArray<TooltipEntry>;
	unit?: string;
	labelPrefix?: string;
	formatLabel?: (row: any) => string;
}

export function ChartTooltip({ active, label, payload, unit = '', labelPrefix = '', formatLabel }: ChartTooltipProps) {
	if (!active || !payload || payload.length === 0) return null;

	const displayLabel = formatLabel && payload[0].payload ? formatLabel(payload[0].payload) : `${labelPrefix}${label}`;

	return (
		<div className="rounded-lg border border-raro-gray-200 bg-white p-3 text-xs shadow-lg">
			{displayLabel && (
				<p className="mb-1 font-semibold text-raro-gray-900">{displayLabel}</p>
			)}
			{payload.map((entry, idx) => (
				<p key={`${entry.name}-${idx}`} className="flex items-center gap-2 text-raro-gray-700">
					<span className="h-2 w-2 rounded-full" style={{ backgroundColor: entry.color }} />
					<span>{entry.name}:</span>
					<span className="font-semibold">{entry.value}{unit}</span>
				</p>
			))}
		</div>
	);
}
